/**
 * customer numbers that are locked from editing service contracts
 * currently this only applies to customer ITS
 * */
const LOCKED_CUSTOMER_NUMBERS = [37117];

export const useLockedServiceContractCustomers = (customerId: number) => {
  return LOCKED_CUSTOMER_NUMBERS.includes(customerId);
};
